<template>
  <div
    ref="headerButtons"
    class="header-buttons position-relative pb-3 text-right"
  >
    <div class="d-flex align-items-center justify-content-between">
      <router-link
        class="nav-link back-button cursor-pointer"
        :to="{
          name: orderId ? 'orderSubmissionOrder' : 'orderSubmission',
          params: { id: id, orderId: orderId }
        }"
      >
        <font-awesome-icon class="mr-2" :icon="icons.faLongArrowAltLeft" />
        Back
      </router-link>

      <div
        class="d-flex justify-content-between"
        :style="{ minWidth: widthApproveButtons }"
      >
        <button class="btn regular blue flex-grow-1" @click="approveFunction">
          APPROVE
        </button>

        <ModalChangeDesign
          class="flex-grow-1"
          :id="id"
          :order-id="orderId"
          :on-change="onChange"
          :change-label="changeLabel"
          v-if="
            changeLabel !== 'design' || (!isReorder && !artistModifiedColorUp)
          "
        >
          <span>{{ `Change ${changeLabel}` }}</span>
        </ModalChangeDesign>

        <button
          title="Download"
          class="btn btn-outline-primary btn-download-pdf d-flex flex-column ml-3 justify-content-center"
          @click="onDownload"
        >
          <font-awesome-icon class="ml-1" :icon="icons.faFilePdf" />
          <font-awesome-icon class="mt-2" :icon="icons.faDownload" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'

import ModalChangeDesign from '@/components/Front/orderSubmission/ModalChangeDesign'
import {
  faFilePdf,
  faDownload,
  faLongArrowAltLeft
} from '@fortawesome/free-solid-svg-icons'

@Component({
  components: {
    ModalChangeDesign
  }
})
export default class ApproveButtons extends Vue {
  @Prop({
    type: String,
    required: false,
    default: null
  })
  id

  @Prop({
    type: String,
    required: false,
    default: null
  })
  orderId

  @Prop({
    type: Function,
    required: false,
    default: () => {}
  })
  onApprove

  @Prop({
    type: Function,
    required: false,
    default: undefined
  })
  onChange

  @Prop({
    type: String,
    required: false,
    default: 'design'
  })
  changeLabel

  @Prop({
    type: [String, Boolean],
    required: false,
    default: null
  })
  pdfLink

  // @Prop({
  //   type: Function,
  //   required: false,
  //   default: () => {}
  // })
  // onDownload

  @Prop({
    type: String,
    required: false,
    default: 'auto'
  })
  widthApproveButtons

  icons = {
    faFilePdf,
    faDownload,
    faLongArrowAltLeft
  }

  approveFunction() {
    this.onWaitUntilDownload().then(() => {
      this.onApprove()
    })
  }

  onWaitUntilDownload() {
    return new Promise((resolve, reject) => {
      if (!this.pdfLink) {
        this.showLoading()
        this.toastMessageBottomEnd(`Generating File Pdf. Please wait.`)
        const interval = setInterval(() => {
          // console.log('this.pdfLink', this.pdfLink)
          if (this.pdfLink) {
            clearTimeout(interval)

            this.hideLoading()
            resolve()
          }
        }, 500)
      } else {
        // console.log('this.pdfLink', this.pdfLink)
        resolve()
      }
    })
  }

  onDownload() {
    this.onWaitUntilDownload().then(() => {
      window.open(this.pdfLink, '_blank')
    })
  }
}
</script>
<style lang="scss" scoped>
.back-button {
  // position: absolute;
  // left: 0;
  // cursor: pointer;
  color: $base-black-color;
  font-size: 16px;
}
</style>
